import {
  IonList,
  IonItem,
  IonLabel,
  IonSkeletonText,
  IonText,
  IonThumbnail,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillLeave,
  useIonViewDidEnter,
} from "@ionic/react";

import { RefresherEventDetail } from "@ionic/core";

import React from "react";

import { useHistory } from "react-router";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import moment from "moment";

import PageCmp from "../../components/Page/Page";
import NumberFormat from "../../components/NumberFormat";

import Status from "../../components/Passage/Status/status";
import PageError from "../Error";

import { BusStation } from "./BusStation";

import { Ticket } from "../../interfaces/ticket";

import IonToolbar from "./IonToolbar";

const GET_TICKETS = gql`
  query getTickets {
    getTickets {
      id
      price
      date
      hour
      minutes
      status
      car {
        organization {
          name
          image
        }
      }
    }
  }
`;

const listLoading = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const Page: React.FC = () => {
  const { push } = useHistory();

  const { loading, error, data, stopPolling, startPolling, refetch } = useQuery(
    GET_TICKETS,
    {
      fetchPolicy: "no-cache",
      pollInterval: 5000,
    }
  );

  useIonViewDidEnter(() => {
    // if (refetch && !loading && data !== undefined && state) refetch();
    if (startPolling) startPolling(5000);
  }, [startPolling, refetch, loading]);

  useIonViewWillLeave(() => {
    if (stopPolling) {
      stopPolling();
    }
  }, [stopPolling]);

  const handleDetail = (id: number) => push(`/page/passage/${id}`);

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    refetch().finally(() => event.detail.complete());
  };

  if (error) {
    return <PageError name="" error="network" />;
  }

  if (loading) {
    return (
      <PageCmp name="">
        <IonList>
          {listLoading.map((value) => (
            <IonItem key={value}>
              <IonSkeletonText
                animated
                style={{ width: "27px", height: "27px" }}
                slot="start"
              />
              <IonLabel>
                <h3>
                  <IonSkeletonText animated style={{ width: "50%" }} />
                </h3>
                <p>
                  <IonSkeletonText animated style={{ width: "80%" }} />
                </p>
                <p>
                  <IonSkeletonText animated style={{ width: "60%" }} />
                </p>
              </IonLabel>
            </IonItem>
          ))}
        </IonList>
      </PageCmp>
    );
  }

  const { getTickets } = data;

  return (
    <PageCmp name="" ionToolBar={<IonToolbar />}>
      <BusStation show={getTickets.length === 0} />
      <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
        <IonRefresherContent />
      </IonRefresher>
      <IonList>
        {getTickets.map(
          ({ id, date, hour, minutes, price, status, car }: Ticket) => (
            <IonItem button key={id} onClick={() => handleDetail(id)}>
              <IonThumbnail slot="start">
                <img
                  style={{ borderRadius: "50%" }}
                  src={car.organization.image}
                  alt={car.organization.name}
                />
              </IonThumbnail>
              <IonLabel className="ion-text-wrap">
                <IonText>
                  <h3>
                    {moment(date).format("DD/MM/YYYY")} às {hour}:{minutes}
                  </h3>
                </IonText>
                <p>
                  {car.organization.name} {" - "}
                  <NumberFormat value={price} />
                </p>
                <p>
                  {/* <IonSkeletonText animated style={{ width: "60%" }} /> */}
                </p>
              </IonLabel>
              <Status type={status} />
            </IonItem>
          )
        )}
      </IonList>
    </PageCmp>
  );
};

export default Page;
